import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "../../../comn";
import Base, { api } from "@/comn";
import { comnUtils } from "@/comn/utils";

export const BASE = {
    path: `${ptlEnvs.base}/ewc/svr`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/ewc/svr`,
};

export const URLS = {
    ewci1001003q: `${BASE.path}/ewci1001003q`,
    ewci1001004q: `${BASE.path}/ewci1001004q`,
};

export const APIS = {
    // Get the Server list. !== 서버 목록을 조회한다.==!
    getSvrList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },

    // Get the Namespace list. !== namespace 전체 목록을 조회한다. ==!
    getAllNmspaceList: () => {
        return api.get(`${BASE.api}/name-spaces`);
    },
    
    // Gets Server information. !== 서버 정보를 조회한다.==!
    getSvrInfo: (namespace: any, name: any) => {
        return api.get(`${BASE.api}/${namespace}/${name}`);
    },
};


export const SF_SVR_SRCH: TFormSchema = {
    id: "form_svrSrch",
    schema: {
        namespace: {
            type: "select",
            label: "L_NAME_SPACE",
        },
        name: {
            type: "text",
            label: "L_SVR_NM",
        },
        status: {
            type: "select",
            label: "L_USE_STTS",
        }
    },
};

export const SG_SVR_LIST: TGridSchema = {
    id: "grid_svrList",
    options: {
        pagination: "in",
        edit: false,
        index: true,
        height: 500,
    },

    head: [
        { cells: [{ header: "L_NAME_SPACE", binding: "namespace", width: "*" }] },
        { cells: [{ header: "L_SVR_NM", binding: "name", width: "*" }] },
        { cells: [{ header: "L_SVR_IP", binding: "ip", width: "*" }] },
        { cells: [{ header: "L_USE_STTS", binding: "useStatus", width: "*" }] },
        { cells: [{ header: "L_LAST_MDFY_DTM", binding: "lastUpdate", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "namespace" , align:'left' }] },
        { cells: [{ binding: "name" , align:'left'  }] },
        { cells: [{ binding: "ip" }] },
        { cells: [{ binding: "useStatus" }] },
        { cells: [{ binding: "lastUpdate", type:'datetime' }] },
    ],
};

export const SF_SVR_INFO: TFormSchema = {
    id: "form_svrInfo",
    schema: {
        namespace: { type: "text", label: "L_NAME_SPACE", edit: false },
        generateName: { type: "text", label: "L_SVR_NM", edit: false },
        ip: { type: "text", label: "L_SVR_IP", edit: false },
        useStatus: { type: "text", label: "L_USE_STTS", edit: false },
        lastUpdate: { type: "datetime", label: "L_LAST_MDFY_DTM", edit: false },
    },
};


export const SG_SVR_LBL_LIST: TGridSchema = {
    id: "grid_svrLblList",
    options: {
        pagination: "in",
        edit: false,
        index: true,
        height: 500,
    },

    head: [
        { cells: [{ header: "L_LBL_ID", binding: "labelId", width: "*" }] },
        { cells: [{ header: "L_LBL_NM", binding: "labelName", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "labelId", align:'left' }] },
        { cells: [{ binding: "labelName" }] },
    ],
};